<template>
  <v-list>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title
          class="alert-categories-title"
        >
          Alert Categories
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider />

    <v-list-item-group mandatory>
      <v-list-item
        v-for="category in categories"
        :key="category.id"
        :value="category.id"
        @click="onSelectCategory(category.id)"
      >
        <v-list-item-icon>
          <v-icon :color="category.color">
            {{ category.icon }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="alert-categories-name">
            {{
              category.name
            }}
          </v-list-item-title>
          <v-list-item-subtitle class="alert-categories-description">
            {{
              category.description
            }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "AlertCategoriesList",
  components: {},
  props: {
    onSelectCategory: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      drawer: true,
    };
  },
  computed: {
    ...mapState("alerts", ["categories"]),
  },
};
</script>

  <style scoped>
.v-list {
  background-color: var(--color-surface) !important;
}

.v-navigation-drawer {
  background-color: var(--color-surface) !important;
}

.alert-categories-name,
.alert-categories-title {
  color: var(--color-text) !important;
}

.alert-categories-description {
  color: var(--color-text-muted) !important;
}
</style>
